"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
require("core-js/modules/es6.function.name");
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var domain = process.env.VUE_APP_BASE_API_ADMIN;
var headerParam = function headerParam() {
  return {
    user: encodeURIComponent(localStorage.name),
    group: encodeURIComponent(localStorage.group)
  };
};
var ServiceModule = /*#__PURE__*/function (_Service) {
  function ServiceModule() {
    (0, _classCallCheck2.default)(this, ServiceModule);
    return _callSuper(this, ServiceModule, arguments);
  }
  (0, _inherits2.default)(ServiceModule, _Service);
  return (0, _createClass2.default)(ServiceModule, [{
    key: "getList",
    value: function getList(param) {
      // return this.http.get(domain + `/api/wq?${qs.stringify(param)}`)
      return this.http.get(domain + "/api/myQuestionList?".concat(_qs.default.stringify(param)), {
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "getAllList",
    value: function getAllList(param) {
      return this.http.get(domain + "/api/wq?".concat(_qs.default.stringify(param)));
    }
  }, {
    key: "getClassList",
    value: function getClassList(param) {
      var id = param.id;
      return this.http.get(domain + "/api/wq_ctype/".concat(id));
    }

    // 有权限
  }, {
    key: "getPanelList",
    value: function getPanelList() {
      // return this.http.get(domain + '/api/wp_menu')
      return this.http.get(domain + '/api/myConfigList', {
        headers: _objectSpread({}, headerParam())
      });
    }
    // 查询置顶状态
  }, {
    key: "searchTopStatus",
    value: function searchTopStatus() {
      // return this.http.get(domain + '/api/wp_menu')
      return this.http.post(domain + '/api/pin/overtimeInfo', {
        headers: _objectSpread({}, headerParam())
      });
    }
  }, {
    key: "getPaneAllList",
    value: function getPaneAllList() {
      return this.http.get(domain + '/api/wp_menu');
      // return this.http.get(domain + '/api/add/myConfigList', {
      //   headers: {
      //     ...headerParam()
      //   }
      // })
    }
  }, {
    key: "addEntity",
    value: function addEntity(param) {
      return this.http.post(domain + '/api/wq/', param);
      // question_name	string	必须 工单问题(名称)
      // config_id	integer	 必须 工单版块编号
      // type_id	integer	必须 工单分类编号
      // status	integer	必须 启用状态 0:禁用 1:启用
      // mark	string	非必须 备注
      // sort	integer	 非必须 排序
    }
  }, {
    key: "removeEntity",
    value: function removeEntity(param) {
      var id = param.id;
      return this.http.delete(domain + "/api/wq/".concat(id));
    }
  }, {
    key: "modifyEntity",
    value: function modifyEntity(param) {
      return this.http.put(domain + '/api/wq/', param);
      // question_name	string	必须 工单问题(名称)
      // config_id	integer	 必须 工单版块编号
      // type_id	integer	必须 工单分类编号
      // status	integer	必须 启用状态 0:禁用 1:启用
      // mark	string	非必须 备注
      // sort	integer	 非必须 排序
    }
  }, {
    key: "fetchEntity",
    value: function fetchEntity(param) {
      var id = param.id;
      return this.http.get(domain + "/api/wq/".concat(id));
    }
  }, {
    key: "getManager",
    value: function getManager(param) {
      return this.http.get("/v2/department/".concat(param.id, "/manager?").concat(_qs.default.stringify(param.token)));
    }
  }, {
    key: "isShowTools",
    value: function isShowTools(param) {
      return this.http.post("/api/set/matchTool", param);
    }
  }]);
}(_serviceBase.default);
var _default = exports.default = new ServiceModule();